

































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HonorActions extends Vue {
  @Prop() type!: 'positive' | 'negative' | 'redeeming';
  @Prop() actions!: any[];

  goTo(route: string) {
    this.$router.push(route);
  }
}
